// extracted by mini-css-extract-plugin
module.exports = {"container":"Register_container__0cokA","input":"Register_input__GVbwh","loginText":"Register_loginText__yDon8"};